import { useMutation } from '@tanstack/react-query';

import ExternalService from '../services/ExternalService/ExternalApiService';
import { type IDPConfig, type IDPConfigKosmos } from '../services/types';

interface ApiResponse {
  success: boolean; // Indicates if the API call was successful
  errorMessage: string; // Optional message from the server
  data: IDPConfig[] | IDPConfigKosmos[]; // The actual data returned by the API
  error: string; // Error details in case of failure
  status?: number;
  ok?: boolean;
}

/**
 * Updates the IDP configuration for a given vendor.
 *
 * @param {IDPConfig | IDPConfigKosmos} vendor - The vendor-specific IDP configuration to be updated.
 * @returns {Promise<ApiResponse>} A promise resolving to the updated configuration response.
 */
const putConfig = async (vendor: IDPConfig | IDPConfigKosmos) => {
  const response = (await ExternalService.putIDPConfig(vendor)) as ApiResponse;

  return response;
};

/**
 * Custom hook to perform the putConfig mutation.
 *
 * @returns {UseMutationResult<ApiResponse, unknown, IDPConfig | IDPConfigKosmos, unknown>} The result of the mutation.
 */
const useUpdateIDPProvider = () =>
  useMutation({
    mutationFn: (vendor: IDPConfig | IDPConfigKosmos) => putConfig(vendor),
  });

export default useUpdateIDPProvider;
